import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import debounce from 'just-debounce-it'
import AsyncSelect from 'react-select/async'

/**
 * @param {String} placeholder
 * 
 * @param {Number} debounceTime
 * Temps de delay mínim entre carrega d'opcions
 * 
 * @param {Function} asyncLoadOptionsFunc (value,callback)
 * Funcio asincrona que a partir del value obté les opcions i es retornen a través del callback
 * 
 * @param {Function} onSelected 
 * Callback -> es crida quan es selecciona un element
 * 
 * @param {Function} getOptionLabel
 * Funcio que a partir d'una opció retorna el label del select
 * 
 * @param {Function} getOptionValue
 * Funcio que a partir d'una opcio retorna el value del select
 * 
 * 
 * @returns {SelectDynamic}
 
 */
const SelectDynamic = ({
  placeholder,
  debounceTime = 350,
  asyncLoadOptionsFunc = () => {},
  onSelected = () => {},
  getOptionLabel = () => {},
  getOptionValue = () => {},
}) => {
  const [selectedValue, setSelectedValue] = useState()
  const handleChange = (selOption) => {
    setSelectedValue(selOption)

    onSelected(selOption)
  }

  const loadOptions = useCallback(debounce(asyncLoadOptionsFunc, debounceTime), [
    asyncLoadOptionsFunc,
  ])

  return (
    <AsyncSelect
      className="w-100"
      placeholder={placeholder}
      value={selectedValue}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      loadOptions={loadOptions}
      onChange={handleChange}
    />
  )
}

SelectDynamic.propTypes = {
  placeholder: PropTypes.string,
  debounceTime: PropTypes.number,
  asyncLoadOptionsFunc: PropTypes.func,
  onSelected: PropTypes.func,
  getOptionValue: PropTypes.func,
  getOptionLabel: PropTypes.func,
}

export default SelectDynamic
